import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from '../style/img/icons/InfoIcon';

class ButtonWithHelpText2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    toggleHelpText() {
        this.setState({ open: !this.state.open });
    }

    render() {
        if (this.props.force_show_info && this.props.force_show_info === true) {
            return (
                <div className="help-text-button-container">
                    <div className="help-text-button">
                        <button
                            type={this.props.type}
                            className="btnSubmit"
                            id={this.props.id}
                        >
                            {this.props.text}
                        </button>

                    </div>

                </div>
            );
        } else {
            return (
                <div className="help-text-button-container">
                    <div className="help-text-button">
                        <button
                            type={this.props.type}
                            className="btnSubmit"
                            id={this.props.id}
                        >
                            {this.props.text}
                        </button>

                        <div className="toggle-help-button-wrapper">
                            <button
                                className="toggle-help-button center-block"
                                onClick={this.toggleHelpText.bind(this)}
                                type="button"
                            >
                                <InfoIcon />
                                <span>Informasjon</span>
                            </button>
                        </div>


                    </div>
                </div>
            );
        }
    }
}

ButtonWithHelpText2.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    helpText: PropTypes.string.isRequired,
    force_show_info: PropTypes.bool,
    id: PropTypes.string
};

export default ButtonWithHelpText2;
